import { render, staticRenderFns } from "./CompanyMergeCard.vue?vue&type=template&id=73f07d68&scoped=true&"
import script from "./CompanyMergeCard.vue?vue&type=script&lang=js&"
export * from "./CompanyMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMergeCard.vue?vue&type=style&index=0&id=73f07d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f07d68",
  null
  
)

export default component.exports